/* eslint-disable no-shadow */
import React, { useEffect, useState } from 'react'
import StreetMarketPage from 'src/pages/ReportsPages/ReportsBoard/CommercialsReportsPages/StreetMarketPage'
import boardReportsService from 'src/services/boardReportsService'

const StreetMarketContainer = () => {
  const [total, setTotals] = useState([])
  const [gTotal, setGTotals] = useState([])
  const [gScooterA, setGScooterA] = useState([])
  const [gScooterB, setGScooterB] = useState([])
  const [totalSegment, setTotalsSegment] = useState([])
  const [selectedDate, setSelectedDate] = useState(new Date())

  const [transportTotal, setTransportTotal] = useState([])
  const [gTotalT, setGTotalT] = useState([])
  const [totaTransportSegment, setGTSegment] = useState([])
  const [gTotalTA, setGTA] = useState([])
  const [gTotalTB, setGTB] = useState([])

  const [totalWork, setTotalWork] = useState([])
  const [gTotalWork, setGTotalWork] = useState([])

  const [totalDeportives, setTotalDeportives] = useState([])
  const [gTotalDeportives, setGTotalDeportives] = useState([])

  const [totalDeportivesSegment, setTotalDeportivesSegment] = useState([])
  const [gTotalDA, setTotalGDA] = useState([])
  const [gTotalDB, setTotalGDB] = useState([])

  const reloadStreetMarket = async () => {
    const [total, gTotal, gScooterA, gScooterB, totalSegment] = await Promise.all([
      boardReportsService.getTotalMarkes('12', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('12', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('13a', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('13b', selectedDate.getFullYear()),
      boardReportsService.getTotalMarkes('13', selectedDate.getFullYear()),
    ])
    setTotals(total)
    setGTotals(gTotal)
    setGScooterA(gScooterA)
    setGScooterB(gScooterB)
    setTotalsSegment(totalSegment)
  }

  const reloadStreetTransport = async () => {
    const [transportTotal, gTotalT, totaTransportSegment, gTotalTA, gTotalTB] = await Promise.all([
      boardReportsService.getTotalMarkes('14', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('14', selectedDate.getFullYear()),
      boardReportsService.getTotalMarkes('15', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('15a', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('15b', selectedDate.getFullYear()),
    ])
    setTransportTotal(transportTotal)
    setGTotalT(gTotalT)
    setGTSegment(totaTransportSegment)
    setGTA(gTotalTA)
    setGTB(gTotalTB)
  }

  const reloadMarketWork = async () => {
    const [totalWork, gTotalWork] = await Promise.all([
      boardReportsService.getTotalMarkes('16', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('16', selectedDate.getFullYear()),
    ])

    setTotalWork(totalWork)
    setGTotalWork(gTotalWork)
  }

  const reloadMarketDeportives = async () => {
    const [totalDeportives, gTotalDeportives, totalDeportivesSegment, gTotalDA, gTotalDB] = await Promise.all([
      boardReportsService.getTotalMarkes('18', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('17', selectedDate.getFullYear()),
      boardReportsService.getTotalMarkes('19', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('18a', selectedDate.getFullYear()),
      boardReportsService.getTotalMarketsGraphics('18b', selectedDate.getFullYear()),
    ])

    setTotalDeportives(totalDeportives)
    setGTotalDeportives(gTotalDeportives)
    setTotalDeportivesSegment(totalDeportivesSegment)
    setTotalGDA(gTotalDA)
    setTotalGDB(gTotalDB)
  }

  const handleDateChange = value => {
    setSelectedDate(value)
  }
  useEffect(() => {
    reloadStreetMarket()
  }, [selectedDate])

  useEffect(() => {
    reloadStreetMarket()
    reloadStreetTransport()
    reloadMarketDeportives()
    reloadMarketWork()
  }, [selectedDate])

  return (
    <StreetMarketPage
      totalWork={totalWork}
      gTotalWork={gTotalWork}
      totalDeportives={totalDeportives}
      totalDeportivesSegment={totalDeportivesSegment}
      gTotalDeportives={gTotalDeportives}
      gTotalT={gTotalT}
      total={total}
      gTotal={gTotal}
      gTotalDA={gTotalDA}
      gTotalDB={gTotalDB}
      gTotalTA={gTotalTA}
      gTotalTB={gTotalTB}
      gScooterA={gScooterA}
      gScooterB={gScooterB}
      totalSegment={totalSegment}
      selectedDate={selectedDate}
      transportTotal={transportTotal}
      totaTransportSegment={totaTransportSegment}
      handleDateChange={handleDateChange}
    />
  )
}

export default StreetMarketContainer
